export class ConfigError extends Error {
  type = 'ConfigError';

  static NotFound(key: unknown) {
    return new ConfigError(`Key not found in config: ${key}`);
  }
}
